import React from "react";
import { Container } from "react-bootstrap";
import { skillsData } from "../data/SkillsData";
import Slider from "react-slick";
import SkillCard from "./skillcard/SkillCard";

const Skills = () => {
  // Slider settings
  let settings = {
    dots: false,
    arrows: true,
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };
  // Slider settings

  return (
    <div className='skill-section'>
      <h1>Skills</h1>
      <Container>
        <Slider {...settings}>
          {skillsData.map((data, i) => (
            <SkillCard skill={data} />
          ))}
        </Slider>
      </Container>
    </div>
  );
};

export default Skills;
